import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 active:scale-[0.98]",
  {
    variants: {
      variant: {
        // 🟢 Verde Brasil - Ação principal
        default:
          "bg-primary text-primary-foreground shadow-verde hover:bg-primary/90 hover:shadow-lg",
        
        // 🔴 Destrutivo - Vermelho suave
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        
        // ⚪ Outline - Borda com cor primária
        outline:
          "border-2 border-primary/20 bg-background text-primary hover:bg-primary/5 hover:border-primary/40",
        
        // 🔵 Azul Brasil - Secundário
        secondary:
          "bg-secondary text-secondary-foreground shadow-azul hover:bg-secondary/90 hover:shadow-lg",
        
        // 👻 Ghost - Sutil
        ghost: "hover:bg-primary/5 hover:text-primary text-foreground",
        
        // 🔗 Link - Texto verde
        link: "text-primary underline-offset-4 hover:underline font-medium",
        
        // 🟡 Amarelo Brasil - Destaque especial
        accent:
          "bg-accent text-accent-foreground shadow hover:bg-accent/90 hover:shadow-md border border-accent/20",
        
        // ⚪ Soft - Cinza suave
        soft:
          "bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground",
      },
      size: {
        default: "h-10 px-5 py-2.5",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-12 rounded-xl px-8 text-base",
        xl: "h-14 rounded-xl px-10 text-lg",
        icon: "h-10 w-10",
        "icon-sm": "h-8 w-8 rounded-md",
        "icon-lg": "h-12 w-12 rounded-xl",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }